import { render, staticRenderFns } from "./provision-summary.vue?vue&type=template&id=5662afe4&"
import script from "./provision-summary.vue?vue&type=script&lang=tsx&"
export * from "./provision-summary.vue?vue&type=script&lang=tsx&"
import style0 from "./provision-summary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports